<script setup lang="ts">
import { shallowRef, watch } from 'vue'
import { Search } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { Target } from '@/types'
import { useSearchStore } from '@/stores/searchStoreV2'
import { useAuthStore } from '@/stores/authStore'

const { t } = useI18n()
const searchStore = useSearchStore()

const { openPanel, emptyPrompts, atleastOneFormatActive, atleastOneRenderActive } = storeToRefs(searchStore)

const route = useRoute()
const router = useRouter()
const showSearchButton = shallowRef<boolean>(false)

watch(() => route.path, () => {
	showSearchButton.value = route.name === Target.Gallery || route.name === Target.Collection || route.name === Target.UserGallery || route.name === Target.Creations
}, { immediate: true })

function togglePanel() {
	if (!useAuthStore().isAuth()) {
		router.push('/account/signup')
	}
	else {
		openPanel.value = !openPanel.value
	}
}
</script>

<template>
	<Button
		v-if="showSearchButton"
		class="button-search flex-center"
		:class="{ 'search-highlight': !emptyPrompts || atleastOneFormatActive || atleastOneRenderActive }"
		@click="togglePanel"
	>
		<template #default>
			<div class="flex-center gap-1">
				<Search class="lucide-button-icon" />
				<span class="search-text xsp:text-xsp text-xs">{{ t('common.search') }}</span>
			</div>
		</template>
	</Button>
</template>

<style scoped lang="scss">
.search-highlight {
	@apply bg-gradient-to-r from-orange-600 via-orange-400 to-orange-600 animate-wave hover:from-orange-500 hover:via-orange-300 hover:to-orange-500;
	background-size: 200%;
}
.button-search {
	@apply rounded-full text-xsp py-2 menuxl:px-4 px-2 font-extrabold gap-1 bg-orange-600 bg-transparent border-orange-400;
}
</style>
